import type {
  DashboardSidebarName,
  DashboardState,
} from "metabase/redux/store";

import type { EmbedDisplayParams } from "./types";

export const SIDEBAR_NAME: Record<DashboardSidebarName, DashboardSidebarName> =
  {
    addQuestion: "addQuestion",
    action: "action",
    chartSettings: "chartSettings",
    clickBehavior: "clickBehavior",
    editParameter: "editParameter",
    filters: "filters",
    sharing: "sharing",
    settings: "settings",
    info: "info",
  };

export const INITIAL_DASHBOARD_STATE: DashboardState = {
  dashboardId: null,
  selectedTabId: null,
  editingDashboard: null,
  dashboards: {},
  dashcards: {},
  dashcardData: {},
  linkTargets: { questions: {}, dashboards: {} },
  parameterValues: {},
  draftParameterValues: {},
  loadingDashCards: {
    loadingIds: [],
    loadingStatus: "idle" as const,
    startTime: null,
    endTime: null,
  },
  loadingControls: {
    isLoading: false,
  },
  isAddParameterPopoverOpen: false,
  isNavigatingBackToDashboard: false,
  slowCards: {},
  sidebar: { props: {} },
  missingActionParameters: null,
  autoApplyFilters: {
    toastId: null,
    toastDashboardId: null,
  },
  tabDeletions: {},
};

export const DASHBOARD_SLOW_TIMEOUT = 15 * 1000;

export const DEFAULT_DASHBOARD_DISPLAY_OPTIONS: EmbedDisplayParams = {
  background: true,
  bordered: false,
  titled: true,
  cardTitled: true,
  hideParameters: null,
  font: null,
  theme: "light",
  downloadsEnabled: { pdf: true, results: true },
  // TODO: (Kelvin 2025-11-17) this will be removed when I work on EMB-1025
  withSubscriptions: true,
  withFooter: true,
  clickActionMode: undefined,
};
